import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
  uri: "https://api2.emos.id/generatesp/graphql",
  cache: new InMemoryCache(),
  headers: {
    Authorization:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MzY0OTYyMzJ9._299Kzn_xSY155iwgq4-o1N8w5BlneJpH-uPzBWdc7Q",
  },
});

export default client;
